import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';

import NotFoundPage from '@/features/App/404';
import ServerErrorPage from '@/features/App/500';
import AppIndex from '@/features/App/AppIndex';
import AppLayout from '@/features/App/AppLayout';
import LoginPage from '@/features/App/login';
import RequestAccessPage from '@/features/Setting/Integrations/integrationRedirection/request-access';
import StaticDashboard2Page from '@/features/StaticDashboard2/StaticDashboard2Page';
import StaticStudioItemDetailPage from '@/features/Studio/pages/static-studio-item-detail-page';
import CreateWorkspace from '@/features/Workspace/create-workspace';
import CreateWorkspaceComplete from '@/features/Workspace/create-workspace-complete';
import WorkspaceLayout from '@/features/Workspace/WorkspaceLayout';
import { RootLayout } from '@/layouts/root-layout';
import SuspenseLayout from '@/layouts/SuspenseLayout';

import integrationRoutes from './integrationRoutes';
import shareRoutes from './publicRoutes';
import workspaceRoutes from './workspaceRoutes';

const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route element={<SuspenseLayout />}>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<AppIndex />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="request-access/:id" element={<RequestAccessPage />} />
          <Route path="500" element={<ServerErrorPage />} />
          <Route path="create-workspace" element={<CreateWorkspace />} />
          <Route
            path="create-workspace-complete"
            element={<CreateWorkspaceComplete />}
          />
          {integrationRoutes}
          {workspaceRoutes}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
      <Route path="/static/dashboard2" element={<StaticDashboard2Page />} />
      <Route path="workspace" element={<WorkspaceLayout />}>
        <Route
          path=":workspace_id/studio/:studio_item_alias/static"
          element={<StaticStudioItemDetailPage />}
        />
      </Route>
      {shareRoutes}
    </Route>,
  ),
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

export default router;
